import { push as Push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Campaign, CampaignType } from "@dev/ee-api/ee-api-models";
import { SimplePopoverPlainOption } from "@dev/ee-components";
import { safelyEncodeBase64Url } from "@dev/ee-tools";
import { CampaignsPaths, pathsParams } from "@/services/dictionaries/Paths";
import { ShowDialog } from "@/store/dialog/actions";
import { CopyCampaignsByNameStart, DeleteCampaigns } from "@/store/campaigns/actions";
import { DropdownOptions } from "@/store/campaigns/types";
import { screenCampaignTypes } from "@/components/Campaigns/CampaignsList/config";

type DropdownAction = (
    e: React.MouseEvent<HTMLElement>,
    option: SimplePopoverPlainOption,
    campaign: Campaign
) => void;

interface DropdownActionHook {
    getDropdownAction: DropdownAction;
}

export const useDropdownAction = (): DropdownActionHook => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const getDropdownAction: DropdownAction = (e, option, campaign) => {
        switch (option.value) {
            case DropdownOptions.Edit:
                if (campaign?.Name) {
                    dispatch(
                        Push(
                            `${CampaignsPaths.CampaignCreatorName.replace(
                                pathsParams.name,
                                safelyEncodeBase64Url(campaign.Name)
                            )}`
                        )
                    );
                }
                break;
            case DropdownOptions.CopyCampaign:
                dispatch(
                    ShowDialog({
                        title: t('copycampaign'),
                        body: `${t('copycampaignconfirmation')} "${campaign.Name}"?`,
                        confirmLabel: t('copy'),
                        cancelLabel: t('cancel'),
                        onClickConfirm: () => dispatch(CopyCampaignsByNameStart(campaign.Name)),
                    })
                );
                break;
            case DropdownOptions.Delete:
                dispatch(DeleteCampaigns([campaign.Name], screenCampaignTypes));
                break;
            case DropdownOptions.ViewDetails:
                dispatch(
                    Push(
                        `${CampaignsPaths.CampaignCreatorDetails.replace(
                            pathsParams.name,
                            safelyEncodeBase64Url(campaign.Name)
                        )}`
                    )
                );
                break;
            case DropdownOptions.ViewReport:
                dispatch(Push(
                    (campaign.Type === CampaignType.AbSplit ? CampaignsPaths.CampaignAbResults : CampaignsPaths.CampaignOverview).replace(':type', campaign.Type).replace(':name', safelyEncodeBase64Url(campaign.Name))
                ));
                break;
            default:
                break;
        }
    }
    return { getDropdownAction };
};
